import { render, staticRenderFns } from "./free-coin-condition.vue?vue&type=template&id=22f0cfdc"
import script from "./free-coin-condition.vue?vue&type=script&lang=js"
export * from "./free-coin-condition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports